import React, {Component} from 'react';
import {Link} from 'react-router-dom'
import {connect} from 'react-redux';
import {checkPermission} from '../common/guards/can';
import ArrowButton from '../common/button-arrow';
import MyStore from './my-store';
import MyStaff from './my-staff';
import TabSelector from '../common/tab-selector/tab-selector';
import {GROUP_OWNER} from '../../data/userGroups';
import UserGroupGuard from '../common/guards/user-group';

import './store-details.css'
class MyStoreDetails extends Component {
  render() {
    const tabs = [
      {
        key: 0,
        name: 'my store',
        body: <MyStore />
      },
      ...checkPermission('handle', 'staff') ? [{
        key: 1,
        name: 'my staff',
        body: <MyStaff />
      }] : [],
    ]
    return (
      <div className="store-details">
        <UserGroupGuard type={GROUP_OWNER}>
          <Link to={'/store-summary'}>
            <ArrowButton
              submit={false}
              arrow={{
                direction: 'left'
              }}
                >Back to stores
              </ArrowButton>
          </Link>
        </UserGroupGuard>

        <TabSelector title="" active={0} data={tabs} />
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    store:          state.store.store,
    relationships:  state.store.relationships,
    fetched:        state.store.fetched,
    fetching:       state.store.fetching,
    order:          state.orders.orderNow,
    newOrderAmount: state.store.newOrderAmount,
    features: state.features
  };
};

export default connect(mapStateToProps)(MyStoreDetails);



// WEBPACK FOOTER //
// ./src/components/store-details/store-details.jsx